export default __webpack_public_path__ + "static/media/Förtunning no 9.f556777a.jpg";